import { lazy } from 'react';
import { Navigate } from 'react-router';
import { TokenAuthPage } from '@/pages/TokenAuthPage';
import type { AppRouteDefinition } from './types';
import { AuthenticatedSessionGuard, SessionTokenGuard } from './guards';

const TokenSessionListPage = lazy(() => import('@/pages/TokenSessionListPage').then(m => ({ default: m.TokenSessionListPage })));
const SessionSurveyPage = lazy(() => import('@/pages/SessionSurveyPage').then(m => ({ default: m.SessionSurveyPage })));
const ConsentPageRoute = lazy(() => import('@/pages/ConsentPageRoute'));
const TrainingPageRoute = lazy(() => import('@/pages/TrainingPageRoute'));
const ConsentListPage = lazy(() => import('@/pages/ConsentListPage'));
const TrainingListPage = lazy(() => import('@/pages/TrainingListPage'));
const TrainingSurveyPage = lazy(() => import('@/pages/TrainingSurveyPage'));
const ProfilePage = lazy(() => import('@/pages/ProfilePage'));
const ProfileInfoPage = lazy(() => import('@/pages/ProfileInfoPage'));
const ProfileEditPage = lazy(() => import('@/pages/ProfileEditPage'));
const HistoryPage = lazy(() => import('@/pages/HistoryPage'));
const HistoryDetailPage = lazy(() => import('@/pages/HistoryDetailPage').then(m => ({ default: m.HistoryDetailPage })));
const SettingsPage = lazy(() => import('@/pages/SettingsPage'));
const CompletePage = lazy(() => import('@/pages/CompletePage'));
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'));
const DevSurveyPreview = lazy(() => import('@/pages/DevSurveyPreview'));
const NoticePage = lazy(() => import('@/pages/notice/NoticePage'));
const ClosePage = lazy(() => import('@/pages/ClosePage'));

export const patientRoutes: AppRouteDefinition[] = [
  {
    name: 'token-root',
    path: '/s/:token',
    guard: SessionTokenGuard,
    children: [
      { name: 'token-auth', path: '', component: TokenAuthPage },
      { name: 'token-auth-redirect', path: 'auth', element: <Navigate to="../" replace /> },
      {
        name: 'authenticated-session',
        guard: AuthenticatedSessionGuard,
        children: [
          { name: 'token-session-list', path: 'list', component: TokenSessionListPage },
          { name: 'session-survey', path: 'survey/:sessionId', component: SessionSurveyPage },
          { name: 'consent', path: 'consent', component: ConsentPageRoute },
          { name: 'training', path: 'training', component: TrainingPageRoute },
          { name: 'consent-list', path: 'consent-list', component: ConsentListPage },
          { name: 'training-list', path: 'training-list', component: TrainingListPage },
          { name: 'training-survey', path: 'training-survey/:surveyId', component: TrainingSurveyPage },
          { name: 'profile', path: 'profile', component: ProfilePage },
          { name: 'profile-info', path: 'profile-info', component: ProfileInfoPage },
          { name: 'profile-edit', path: 'profile-edit', component: ProfileEditPage },
          { name: 'history', path: 'history', component: HistoryPage },
          { name: 'history-detail', path: 'history/:historyId', component: HistoryDetailPage },
          { name: 'settings', path: 'settings', component: SettingsPage },
        ],
      },
    ],
  },
  {
    name: 'notice',
    path: '/w/:noticeToken',
    component: NoticePage,
  },
  {
    name: 'dev-survey-preview',
    path: '/dev/survey-preview',
    component: DevSurveyPreview,
    devOnly: true,
  },
  {
    name: 'complete',
    path: '/complete',
    component: CompletePage,
  },
  {
    name: 'close-test',
    path: '/close-test',
    component: ClosePage,
  },
  {
    name: 'root-not-found',
    path: '/',
    component: NotFoundPage,
  },
  {
    name: 'not-found',
    path: '*',
    component: NotFoundPage,
  },
];
